var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8646 0.999956L21.3906 17.5C21.4784 17.652 21.5246 17.8244 21.5246 18C21.5246 18.1755 21.4784 18.3479 21.3906 18.4999C21.3029 18.652 21.1766 18.7782 21.0246 18.866C20.8726 18.9537 20.7002 19 20.5246 19H1.47263C1.2971 19 1.12466 18.9537 0.97264 18.866C0.820624 18.7782 0.69439 18.652 0.606624 18.4999C0.518859 18.3479 0.472655 18.1755 0.472656 18C0.472657 17.8244 0.518864 17.652 0.606631 17.5L10.1326 0.999956C10.2204 0.847949 10.3466 0.721722 10.4987 0.633962C10.6507 0.546202 10.8231 0.5 10.9986 0.5C11.1742 0.5 11.3466 0.546202 11.4986 0.633962C11.6506 0.721722 11.7769 0.847949 11.8646 0.999956ZM3.20463 17H18.7926L10.9986 3.49996L3.20463 17ZM9.99863 14H11.9986V16H9.99863V14ZM9.99863 6.99996H11.9986V12H9.99863V6.99996Z",
    fill: "#F34E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.70fa65fb8275263f380a82fe38c189d2.svg";
export { ForwardRef as ReactComponent };